import { createAxiosInstance } from 'api/api';
import { appConfig } from 'modules/app-config';

export const b2cGraphql = createAxiosInstance({
    baseURL: appConfig.b2cGraphqlApi.url,
    headers: {
        'X-App-Key': appConfig.b2cGraphqlApi.apiKey,
    },
});
